import styled from 'styled-components'

export const HDSpaWrapper = styled.section`
  transition: all 0.8s ease;
  grid-area: 1/1/-1/-1;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
      ${({ theme }) => theme.colors.overlayColor},
      ${({ theme }) => theme.colors.defaultOverlay}
    ),
    url(${(props) => props.bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div {
      flex-direction: row;
      p {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 2.5%;
        text-transform: capitalize;
        font-weight: 800;
      }
    }
  }
  h1 {
    font-size: 2.5rem;
    font-weight: 300;
    text-align: center;
    margin: 0;
    padding: 0;
  }
  h2 {
    font-weight: 800;
    font-size: 2.8rem;
    text-align: center;
    text-transform: capitalize;
    font-family: "tahoma";
    margin: 1.5rem auto;
    padding: 0;
  }
  > span {
    margin: 1rem auto;
    font-size: 2rem;
    font-weight: 600;
    text-transform: capitalize;
  }
`;
export const TimerBox = styled.span`
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  width: 6.5rem;
  height: 6.5rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.defaultOverlay};
  background: linear-gradient(
    ${({ theme }) => theme.colors.overlayColor},
    ${({ theme }) => theme.colors.defaultOverlay}
  );
  transition: all 0.8s ease;
  margin: 0;
  text-shadow: 2px 2px 4px ${({ theme }) => theme.colors.overlayColor};
`;
export const AnimatedElipse = styled.span`
  display: inline-block;
  opacity: 0;
  transform: scale(.8);
  animation: elipseAnimation 2s linear infinite;
  animation-fill-mode: backwards; 
`;
